module.exports = __webpack_public_path__ + "static/media/khat.00fa081d.ogg";